module.exports = __webpack_public_path__ + "static/media/baier_34_trou_noir.b5894e85.jpg";